import React, {useState} from "react";
import {useNavigate} from "react-router-dom"

function useHiringManagerOnboardSuccessful() {
  const [loading, setloading] = useState(false)
  const navigate = useNavigate()

  const onNextClick = async() => {
    setloading(true)
    navigate("/hiring-manager-dashboard")

  };

  const onBackClick = () => {
    navigate(-1)
  }

  return {
    loading,
    onNextClick,
    onBackClick
  };
}

export default useHiringManagerOnboardSuccessful;
